/* Bespoke enquiry form — one question per step.
   - "Show for" (data-show-for) hides steps that don't apply to the chosen piece type
   - Required steps must be answered before moving on
   - "Not sure" skips optional steps (ring size, length)
   - Multi-select answers are joined into one line so the email reads nicely
   - Submits through Shopify's contact form (emailed to the store's contact email) */
(function () {
  'use strict';

  function matches(el, piece) {
    const list = (el.getAttribute('data-show-for') || '').split('|').filter(Boolean);
    return list.length === 0 || (piece && list.indexOf(piece) !== -1);
  }

  function init(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';

    const success = form.querySelector('[data-enquiry-success]');
    if (success) {
      const card = document.getElementById('enquiry-form');
      if (card) card.scrollIntoView({ block: 'start' });
      success.focus({ preventScroll: true });
      return;
    }

    const steps = Array.prototype.slice.call(form.querySelectorAll('[data-question]'));
    if (!steps.length) return;
    const back = form.querySelector('[data-back]');
    const next = form.querySelector('[data-next]');
    const skip = form.querySelector('[data-skip]');
    const submit = form.querySelector('[data-submit]');
    const current = form.querySelector('[data-current]');
    const totalEl = form.querySelector('[data-total]');
    const bar = form.querySelector('[data-progress-bar]');
    const error = form.querySelector('[data-error]');
    const pieceStep = form.querySelector('[data-piece-type]');
    let step = steps[0];

    function piece() {
      if (!pieceStep) return '';
      const checked = pieceStep.querySelector('input:checked');
      return checked ? checked.value.trim().toLowerCase() : '';
    }

    // Steps that apply to the current piece type; switches inner parts (necklace / bracelet) too
    function activeSteps() {
      const p = piece();
      return steps.filter(function (s) {
        const on = matches(s, p);
        s.querySelectorAll('.enquiry-field[data-show-for]').forEach(function (f) {
          const show = matches(f, p);
          f.hidden = !show;
          f.querySelectorAll('input, select').forEach(function (i) { i.disabled = !show; });
        });
        s.querySelectorAll('input, select, textarea').forEach(function (i) {
          if (!on) i.disabled = true;
          else if (!i.closest('.enquiry-field[hidden]')) i.disabled = false;
        });
        return on;
      });
    }

    function showError(msg) {
      error.textContent = msg || '';
      error.hidden = !msg;
    }

    function show(target) {
      const list = activeSteps();
      if (list.indexOf(target) === -1) target = list[0];
      step = target;
      const i = list.indexOf(step);
      steps.forEach(function (s) { s.hidden = s !== step; });
      current.textContent = i + 1;
      totalEl.textContent = list.length;
      bar.style.width = ((i + 1) / list.length) * 100 + '%';
      back.hidden = i === 0;
      const last = i === list.length - 1;
      next.hidden = last;
      submit.hidden = !last;
      skip.hidden = !step.hasAttribute('data-skippable');
      showError('');
    }

    function move(dir) {
      const list = activeSteps();
      const i = list.indexOf(step);
      const target = list[Math.max(0, Math.min(list.length - 1, i + dir))];
      show(target);
      const card = document.getElementById('enquiry-form');
      if (card && card.getBoundingClientRect().top < 0) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const first = step.querySelector('input:not([disabled]):not([type="hidden"]), select:not([disabled])');
      if (first && form.contains(document.activeElement)) first.focus({ preventScroll: true });
    }

    // Returns an error message, or '' when the step is complete
    function validate(s) {
      const kind = s.getAttribute('data-kind');
      if (kind === 'details') {
        const fields = s.querySelectorAll('input[required]');
        for (let k = 0; k < fields.length; k++) {
          if (!fields[k].value.trim()) { fields[k].focus(); return 'Please fill in your ' + fields[k].labels[0].textContent.replace('*', '').trim().toLowerCase() + '.'; }
          if (!fields[k].checkValidity()) { fields[k].focus(); return 'Please enter a valid email address.'; }
        }
        return '';
      }
      if (kind === 'upload') {
        if (s.hasAttribute('data-uploading')) return 'Please wait for your photos to finish uploading.';
        const link = s.querySelector('[data-upload-link]');
        const hasLink = link && link.value.trim() !== '';
        if (s.hasAttribute('data-required') && !s.querySelector('[data-upload-value]').value && !hasLink) return 'Please add a photo or a link to continue.';
        return '';
      }
      if (!s.hasAttribute('data-required')) return '';
      if (kind === 'metal-gem') {
        return s.querySelector('[data-part="metal"] input:checked') ? '' : 'Please choose a metal to continue.';
      }
      if (kind === 'choice' || kind === 'styles') {
        return s.querySelector('input:checked') ? '' : 'Please choose an option to continue.';
      }
      const answer = s.querySelector('[data-answer]:not([disabled])');
      if (answer && !answer.value.trim()) {
        return answer.tagName === 'SELECT' ? 'Please select an option to continue.' : 'Please fill this in to continue.';
      }
      return '';
    }

    next.addEventListener('click', function () {
      const msg = validate(step);
      if (msg) return showError(msg);
      move(1);
    });
    back.addEventListener('click', function () { move(-1); });

    // "Not sure": clear this step's answer, record "Not sure", move on
    skip.addEventListener('click', function () {
      step.querySelectorAll('[data-answer]').forEach(function (a) { a.value = ''; });
      let note = step.querySelector('[data-not-sure]');
      if (!note) {
        note = document.createElement('input');
        note.type = 'hidden';
        note.setAttribute('data-not-sure', '');
        note.name = 'contact[' + step.querySelector('legend').textContent.trim() + ']';
        step.appendChild(note);
      }
      note.value = 'Not sure';
      move(1);
    });

    // Answering a step removes an earlier "Not sure"
    form.addEventListener('input', function (e) {
      const s = e.target.closest('[data-question]');
      const note = s && s.querySelector('[data-not-sure]');
      if (note && e.target.hasAttribute('data-answer')) note.remove();
      showError('');
    });

    // Enter in a text box = Next (not submit) until the last step
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT' && submit.hidden) {
        e.preventDefault();
        next.click();
      }
    });

    form.addEventListener('submit', function (e) {
      const msg = validate(step);
      if (msg) { e.preventDefault(); return showError(msg); }
      activeSteps();
      // "Not sure" steps send just "Not sure"; empty optional answers are left out of the email
      form.querySelectorAll('[data-not-sure]').forEach(function (note) {
        note.closest('[data-question]').querySelectorAll('[data-answer]').forEach(function (a) { a.disabled = true; });
      });
      form.querySelectorAll('[data-question] input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), [data-question] select').forEach(function (i) {
        if (!i.value.trim()) i.disabled = true;
      });
      form.querySelectorAll('[data-upload-value]').forEach(function (i) { if (!i.value) i.disabled = true; });
      // Full name for the email's "from" line
      const first = form.querySelector('[data-first-name]');
      const last = form.querySelector('[data-last-name]');
      form.querySelector('[data-full-name]').value = [first && first.value.trim(), last && last.value.trim()].filter(Boolean).join(' ');
            // Join multi-select answers into one field per question part (e.g. Metal, Gemstone)
      form.querySelectorAll('[data-question]').forEach(function (s) {
        const groups = {};
        s.querySelectorAll('input[type="checkbox"]:not([disabled])').forEach(function (b) {
          (groups[b.name] = groups[b.name] || []);
          if (b.checked) groups[b.name].push(b.value);
          b.disabled = true;
        });
        Object.keys(groups).forEach(function (name) {
          if (!groups[name].length) return;
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = name;
          hidden.value = groups[name].join(', ');
          s.appendChild(hidden);
        });
      });
      submit.disabled = true;
      submit.textContent = 'Sending…';
    });

    form.querySelectorAll('[data-kind="upload"]').forEach(setupUpload);
    show(steps[0]);
  }

  /* ---- Inspiration photos: upload straight to Cloudinary (unsigned preset) ----
     Each photo's link goes into one hidden field, so the enquiry email lists them. */
  const MAX_BYTES = 10 * 1024 * 1024;

  function setupUpload(s) {
    const input = s.querySelector('[data-upload-input]');
    const drop = s.querySelector('[data-upload-drop]');
    const list = s.querySelector('[data-upload-list]');
    const status = s.querySelector('[data-upload-status]');
    const value = s.querySelector('[data-upload-value]');
    const max = parseInt(s.getAttribute('data-max'), 10) || 5;
    const endpoint = 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(s.getAttribute('data-cloud')) + '/image/upload';
    const preset = s.getAttribute('data-preset');
    let items = [];

    function sync(msg) {
      const done = items.filter(function (i) { return i.url; });
      value.value = done.map(function (i, n) { return 'Photo ' + (n + 1) + ': ' + i.url; }).join('\n');
      const busy = items.some(function (i) { return i.pending; });
      if (busy) s.setAttribute('data-uploading', ''); else s.removeAttribute('data-uploading');
      drop.hidden = items.length >= max;
      const err = s.closest('form').querySelector('[data-error]');
      if (!busy && err && err.textContent.indexOf('finish uploading') !== -1) { err.textContent = ''; err.hidden = true; }
      status.textContent = msg || (busy ? 'Uploading…' : done.length ? done.length + ' of ' + max + ' photos added' : '');
    }

    function removeItem(item) {
      if (item.xhr && item.pending) item.xhr.abort();
      items = items.filter(function (i) { return i !== item; });
      item.li.remove();
      if (item.preview) URL.revokeObjectURL(item.preview);
      sync();
    }

    function upload(file) {
      const li = document.createElement('li');
      li.className = 'enquiry-upload__item is-uploading';
      const item = { li: li, pending: true, url: '' };
      try { item.preview = URL.createObjectURL(file); } catch (e) { item.preview = ''; }
      const img = document.createElement('img');
      img.alt = '';
      img.src = item.preview;
      img.onerror = function () { img.replaceWith(Object.assign(document.createElement('span'), { className: 'enquiry-upload__name', textContent: file.name })); };
      const bar = document.createElement('span');
      bar.className = 'enquiry-upload__progress';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'enquiry-upload__remove';
      remove.setAttribute('aria-label', 'Remove photo');
      remove.innerHTML = '&times;';
      remove.addEventListener('click', function () { removeItem(item); });
      li.append(img, bar, remove);
      list.appendChild(li);
      items.push(item);

      const data = new FormData();
      data.append('file', file);
      data.append('upload_preset', preset);
      const xhr = new XMLHttpRequest();
      item.xhr = xhr;
      xhr.open('POST', endpoint);
      xhr.upload.addEventListener('progress', function (e) {
        if (e.lengthComputable) bar.style.width = Math.round((e.loaded / e.total) * 100) + '%';
      });
      xhr.addEventListener('load', function () {
        item.pending = false;
        let res = {};
        try { res = JSON.parse(xhr.responseText); } catch (e) {}
        if (xhr.status >= 200 && xhr.status < 300 && res.secure_url) {
          item.url = res.secure_url;
          li.classList.remove('is-uploading');
          sync();
        } else {
          removeItem(item);
          sync('Sorry, ' + file.name + ' could not be uploaded. Please try another photo.');
        }
      });
      xhr.addEventListener('error', function () {
        item.pending = false;
        removeItem(item);
        sync('Upload failed — please check your connection and try again.');
      });
      xhr.send(data);
      sync();
    }

    function add(files) {
      let msg = '';
      Array.prototype.forEach.call(files, function (file) {
        const isImage = /^image\//.test(file.type) || /\.(heic|heif)$/i.test(file.name);
        if (!isImage) { msg = file.name + ' is not an image.'; return; }
        if (file.size > MAX_BYTES) { msg = file.name + ' is over 10 MB — please choose a smaller photo.'; return; }
        if (items.length >= max) { msg = 'You can add up to ' + max + ' photos.'; return; }
        upload(file);
      });
      if (msg) sync(msg);
    }

    input.addEventListener('change', function () { add(input.files); input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (t) {
      drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-dragging'); });
    });
    ['dragleave', 'drop'].forEach(function (t) {
      drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('is-dragging'); });
    });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer) add(e.dataTransfer.files); });
  }

  function initAll() {
    document.querySelectorAll('form.enquiry-form').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

/* ---- Styled dropdowns: swaps the browser's select menu for a list that matches the site. */
(function () {
  'use strict';

  function enhance(sel) {
    if (sel.dataset.pretty) return;
    sel.dataset.pretty = '1';

    const wrap = document.createElement('div');
    wrap.className = 'enq-select';
    sel.parentNode.insertBefore(wrap, sel);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'enquiry-field__input enq-select__trigger';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    if (sel.id) {
      btn.id = sel.id + '-btn';
      const lab = document.querySelector('label[for="' + sel.id + '"]');
      if (lab) lab.htmlFor = btn.id;
    }

    const list = document.createElement('ul');
    list.className = 'enq-select__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    wrap.appendChild(btn);
    wrap.appendChild(sel);
    wrap.appendChild(list);
    sel.classList.add('enq-select__native');
    sel.tabIndex = -1;
    sel.setAttribute('aria-hidden', 'true');

    function render() {
      const o = sel.options[sel.selectedIndex];
      btn.textContent = o ? o.textContent : '';
      btn.classList.toggle('is-placeholder', !sel.value);
      list.querySelectorAll('li').forEach(function (li) {
        li.setAttribute('aria-selected', sel.value !== '' && li.dataset.value === sel.value ? 'true' : 'false');
      });
    }
    function close() {
      list.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    function open() {
      document.querySelectorAll('.enq-select.is-open').forEach(function (w) { if (w !== wrap && w._close) w._close(); });
      render();
      list.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      const cur = list.querySelector('[aria-selected="true"]') || list.firstElementChild;
      if (cur) cur.focus();
    }
    wrap._close = close;

    Array.prototype.forEach.call(sel.options, function (o) {
      if (o.value === '') return;
      const li = document.createElement('li');
      li.className = 'enq-select__option';
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.dataset.value = o.value;
      li.textContent = o.textContent;
      li.addEventListener('click', function () {
        sel.value = o.value;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        render();
        close();
        btn.focus();
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); li.click(); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); (li.nextElementSibling || li).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (li.previousElementSibling || li).focus(); }
        else if (e.key === 'Escape' || e.key === 'Tab') { close(); btn.focus(); }
      });
      list.appendChild(li);
    });

    btn.addEventListener('click', function () { list.hidden ? open() : close(); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    sel.addEventListener('change', render);
    render();
  }

  function init() { document.querySelectorAll('select.enquiry-field__input').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();